import React from 'react'

import SettingsList from '../../components/Settings/SettingsList'
import SpacesColorCode from '../../components/Settings/Buildings/Spaces/ColorCode'
import Notifications from '../../components/Settings/Notifications'
import LevelStateListeners from '../../components/Settings/Buildings/Levels/StateListeners'
import TransferFees from '../../components/Settings/Financial/TransferFees'
import LateRent from '../../components/Settings/Financial/LateRent'
import QBEnterprise from '../../components/Settings/Integrations/QBEnterprise'
import APIIntegrations from '../../components/Settings/Integrations/APIIntegrations'
import Import from '../../components/Settings/Data/Import'
import ReferralCode from '../../components/Settings/ReferralProgram/ReferralCode'

import SpacesColorCodeUnitTest from '../../unittests/components/Settings/Buildings/Spaces/SpacesColorCodeUnitTest'

import { browserHistory } from 'react-router'
import { user } from '../../core/controllers/user';

export default class SettingsTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    render(){
        const activeSettingsComponent = this.props.settingComponent;
        return (
            <div>
                <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                <div>
                    <SettingsList />
                    {activeSettingsComponent == "levelStateListeners" && (
                        <LevelStateListeners/>
                    )}
                    {activeSettingsComponent == "spacesColorCode" && (
                        <SpacesColorCode/>
                    )}
                    {activeSettingsComponent == "notifications" && (
                        <Notifications/>
                    )}
                    {activeSettingsComponent == "fees" && (
                        <div>
                            <LateRent />
                            <TransferFees />
                        </div>
                    )}
                    {activeSettingsComponent == "qbenterprise" && (
                        <div>
                            <QBEnterprise />
                        </div>
                    )}
                    {activeSettingsComponent == "integrations" && (
                        <div>
                            <APIIntegrations />
                        </div>
                    )}
                    {activeSettingsComponent == "import" && (
                        <Import />
                    )}
                    {activeSettingsComponent == "referral" && (
                        <ReferralCode />
                    )}
                    {/* {activeSettingsComponent == "spacesColorCode" && (
                        // TO BE REMOVED EVENTUALLY
                        // <SpacesColorCodeUnitTest />
                    )} */}
                    {activeSettingsComponent == "" && (
                        // default
                        <div class="col-md-8 col-sm-7 col-xs-12">
                            <div class="card">
                                <div class="header">
                                    <h4 class="title"><i class="pe-7s-edit"></i> </h4>
                                    <p class="category"></p>
                                </div>
                                <div class="content">
                                    <p>No active setting.</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Settings/Settings.jsx